import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch
} from "react-router-dom";
import {InformatRouter} from "./InformatRouter";
import {ScoodleRouter} from "./ScoodleRouter";
import {General404} from "../components/05pages/General404/General404";

export const RootRouter: React.FC = props => {
    return <Router>
        <Switch>
            <Route path={"/Informat"}><InformatRouter/></Route>
            <Route path={"/Scoodle"}><ScoodleRouter/></Route>
            <Route path={["/", `/*`]}>
                <General404/>
            </Route>
        </Switch>
    </Router>
}




